import { Modal } from 'antd';
import QMSDevice from './QMSDevice';
import QMSOverview from './QMSOverview';
import { QMS_Type } from '@vindr/services/apis/qms.api';

const ModalQMS = ({ qmsId, open, setOpen, type }) => {
  return (
    <Modal
      width={"90vw"}
      open={open}
      footer={null}
      onCancel={() => setOpen(false)}
      title={"QMS"}
    >
      {type === QMS_Type.DEVICE && <QMSDevice isPopup={true} qmsId={qmsId} />}
      {type === QMS_Type.OVERVIEW && <QMSOverview isPopup={true} qmsId={qmsId} />}
    </Modal>
  )
}

export default ModalQMS;
